<ion-header class="ion-no-border" [translucent]="true">
  <ion-toolbar
    [color]="mobile() ? '' : 'secondary-detail'"
    [class.detail-page]="!mobile()"
  >
    @if (mobile()) {
    <ion-title> Zahlung </ion-title>
    } @if (!mobile() && paymentSignal(); as payment) {
    <ion-title class="text-center">
      Zahlung vom {{ payment.date | date : "dd.MM.yyyy" }}
    </ion-title>
    }
    <ion-buttons slot="start">
      <ion-back-button [text]="originPage"></ion-back-button>
      @if (isModal) {
      <ion-button (click)="closeModal()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
      }
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="presentPaymentActionSheet()">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </ion-button>
    </ion-buttons>
    @if (loading()) {
    <ion-progress-bar type="indeterminate"></ion-progress-bar>
    }
  </ion-toolbar>
</ion-header>

@if (paymentSignal(); as payment) {
<ion-content class="max-width-content">
  <div [class.padding-content]="!mobile()">
    <ion-card class="mt-2 mb-2" [class.no-margin]="!mobile()">
      @if (studentSignal(); as student) {
      <ion-card-header>
        <ion-card-title
          >{{ student?.forename }} {{ student?.surname }}</ion-card-title
        >
        <ion-card-subtitle
          >Zahlungsdatum:
          {{ payment.date | date : "dd.MM.yyyy" }}</ion-card-subtitle
        >
      </ion-card-header>
      }

      <ion-card-content>
        <div class="flex flex-row justify-between">
          <p>Betrag</p>
          <p>CHF {{ payment.amount | number : "1.2-2" }}</p>
        </div>
      </ion-card-content>
    </ion-card>
    
    <ion-item-divider class="mt-4">
      <ion-label>Zahlungsdetails</ion-label>
    </ion-item-divider>
    <div class="ion-padding !pt-0 !pb-0">
      <ion-col>
        <div class="flex flex-row align-baseline justify-between">
          <ion-label>Zahlungsmethode</ion-label>
          <ion-label>{{ payment.payment_method }}</ion-label>
        </div>
        <div class="mt-2 flex flex-row align-baseline justify-between">
          <ion-label>Erstellt am</ion-label>
          <ion-label>{{ payment.created_at | date : "dd.MM.yyyy HH:mm" }}</ion-label>
        </div>
      </ion-col>
    </div>
  </div>
</ion-content>
}

<ion-footer></ion-footer> 